import CaseAlertDetails from './CaseAlertDetails';

export default CaseAlertDetails;
export { CaseAlertDetails };
